import styled from 'styled-components';
import { IPOStyleMixins } from '../../../styles/index';

export const HeaderWrap = styled.div`
	.ant-select-selection-item {
		.select-label-wrap {
			img {
				opacity: 0;
			}
		}
	}
	.user-info-dom {
		padding: 40px 90px;
		background: linear-gradient(271deg, #5e80ff 0%, #0040e1 100%, #0040e1 100%);
		box-shadow: 0px 4px 20px 0px rgba(11, 22, 40, 0.2);
		border-radius: 6px;
		${IPOStyleMixins.flex('flex', 'flex-start', 'center')}
		position: relative;
		.select-local {
			position: absolute;
			top: 20px;
			right: 20px;
		}
		.head-work-icon {
			position: absolute;
			top: -20px;
			right: 0;
			height: 100%;
		}
	}
	.user-info-ul {
		color: #ffffff;
		margin-left: 40px;
		z-index: 2;
		.info--tip {
			margin-left: 5px;
		}
		.info-name {
			font-size: 30px;
			font-weight: 600;
			> span {
				font-size: 20px;
			}
		}
		.info-li {
			margin-top: 10px;
			font-size: 12px;
			font-weight: 400;
		}
		.tag {
			${IPOStyleMixins.flex('', '', 'center')}
			.tag-wrap {
				${IPOStyleMixins.flex('', '', 'center')}
				margin-left: 5px;
			}
		}
	}
	.info-btn-list {
		margin-top: 40px;
		${IPOStyleMixins.flex('flex', 'end', 'center')}
		gap:20px;
	}
`;
